import { createSlice } from '@reduxjs/toolkit';

const sanitizeUserInfo = (userInfo) => {
  if (!userInfo) {
    return null;
  }

  const safeUserInfo = { ...userInfo };
  delete safeUserInfo.expiresIn;
  delete safeUserInfo.stravaAccessToken;
  delete safeUserInfo.stravaRefreshToken;
  delete safeUserInfo.stravaTokenExpiresAt;

  return safeUserInfo;
};

const initialState = {
  userInfo: localStorage.getItem('userInfo')
    ? sanitizeUserInfo(JSON.parse(localStorage.getItem('userInfo')))
    : null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      const { userInfo } = action.payload;
      const mergedUserInfo = {
        ...state.userInfo,
        ...userInfo,
        token: userInfo?.token || state.userInfo?.token,
      };
      const safeUserInfo = sanitizeUserInfo(mergedUserInfo);
      state.userInfo = safeUserInfo;
      localStorage.setItem('userInfo', JSON.stringify(safeUserInfo));
    },
    logout: (state) => {
      state.userInfo = null;
      localStorage.removeItem('userInfo');
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;

export default authSlice.reducer;
